import { render, staticRenderFns } from "./CandidatesTable.vue?vue&type=template&id=304aae69&"
import script from "./CandidatesTable.vue?vue&type=script&lang=js&"
export * from "./CandidatesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports